export default __webpack_public_path__ + "static/media/collaborate2.7206fba9.png";